import {AfterContentInit, Component, forwardRef, Inject, Input} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JSonSerializer} from '../model/JSonSerializer';
import {ClientService} from '../services/client.service';
import {SessionService} from '../services/session.service';
import {AlertService} from '../services/alert.service';
import {DayType, JSonResult, ModalResult} from '../model/common.model';
import {UserInfo} from "../model/UserInfo";
import {DlgAskYesNoQuestion} from "../common/DlgAskYesNoQuestion";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {DlgErrorMessage} from "../common/DlgErrorMessage";

import {DlgChangePasswordComponent} from "./DlgChangePasswordComponent";
import {DlgAskOTP} from "../common/DlgAskOTP";
import {PrefName} from "../model/Preferences";
import {SecurityPerUser} from "../home/security/model/SecurityPerUser";
import {UIService} from "../services/ui.service";
import {ChatService} from "../services/chat.service";
import {DlgUpdateEmailComponent} from "./DlgUpdateEmailComponent";
import {PopupServices} from "../services/popup.services";
import {Utils} from "../model/Utils";

@Component({
  // selector: 'login-employee',
  templateUrl: './login.component.html' ,
  // providers: [AlertService, PortalService, TranslateService]
})
export class LoginComponent implements AfterContentInit {
  resultMessage: string;
  focusUsername = false;
  focusPassword = false;
  loading = false;
  rememberMe = false;

  router: Router;

  lastSpeedMeasure: Date;
  private _showPassword = false;

  @Input() info = new LoginInfo();
  version = "";
  constructor(
    @Inject(forwardRef(() => ActivatedRoute)) private activatedRoute: ActivatedRoute,
    @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
              @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
              @Inject(forwardRef(() => ChatService)) private chatService: ChatService,
              @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
              @Inject(forwardRef(() => Router)) private routing: Router,
              @Inject(forwardRef(() => SessionService)) public session: SessionService,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
              @Inject(forwardRef(() => UIService)) public uiService: UIService,
  ) {
    console.log('LoginComponent has been created');
    this.router = routing;


  }


  get showPassword(): boolean {
    return this._showPassword;
  }

  set showPassword(value: boolean) {
    this._showPassword = value;
  }

  isFrench(){
  //  console.log(this.translate.instant('LanguageCode'));
    return true;
  }

  onTokenLogin(token: string){
    console.log('token: ' + token);
    this.loading = true;
    this.alertService.clear();
    this.resultMessage = '';
    DayType.ALL;
    // this.resultMessage = '' + this.info.username + ' / ' + this.info.pwd;
    // console.log('Trying to login ' + this.info.username + ' ' + this.translate.instant('HELLO') + ' ' + this.translate.instant('SALUT'));
    console.log('Trying to login ' + this.info.username );
    this.clientService.remoteLoginClient(token).then(
      (res) => {
        this._processLoginInfo(res,true)
      }
    );
  }

  onLoginOpenId(type:string){
    console.log('Trying login openId!');

//    let win = window.open(this.zohoService.retrieveGrantTokenUrl(),'Zoho!','');


    this.clientService.loginOpenIdUrl(type).subscribe((res)=>{
      console.log('Res ',res);
        let win = window.open(res,'OpenId','');
      });
  }

  onLogin() {
    this.loading = true;
    this.alertService.clear();
    this.resultMessage = '';
    // DayType.ALL;
    // this.resultMessage = '' + this.info.username + ' / ' + this.info.pwd;
    // console.log('Trying to login ' + this.info.username + ' ' + this.translate.instant('HELLO') + ' ' + this.translate.instant('SALUT'));
    console.log('Trying to login ' + this.info.username );
    this.clientService.login(this.info.username, this.info.pwd).then(
      (res) => {
        if (!res.success){
          let errorCode:any = res.data;
          if (errorCode === 113){
            this.clientService.getSecurityPerUserForUser(this.info.username).then(
              (res)=>{
               const serial = new JSonSerializer();
               let security = new SecurityPerUser();
               serial.deserialize(res.data,security);

                const modalRef = this.modalService.open(DlgChangePasswordComponent);
                modalRef.componentInstance.populate(this.info.username,this.info.pwd,security);
                modalRef.result.then((result) => {
                  console.log('Result: ' + result);
                  if (ModalResult.OK === result){
                    this.info.pwd = '';
                  }
                  this.loading = false;
                });

            });

          }else{
            this._processLoginInfo(res);
          }
        }else{
          this._processLoginInfo(res)
        }
      }
    );
  }




  private _processLoginInfo(res: JSonResult<UserInfo>,loginWithToken=false){
    if (res.success) {
      console.log('Logged locale: ' + res.data.locale);
      // console.log('Logged In! ' + JSON.stringify(res.data.user,null, 2) );
      // console.log('employeeCode: ' + res.data.user.employeeCode );
      // console.log('Entity Description: ' + res.data.entity.description );
      // console.dir(res.data);

      // delete res.data.units;
      const serialize = new JSonSerializer();
      let ui = new UserInfo();
      serialize.deserialize(res.data, ui );
      // Careful after this line ui is modified and is back to JsonPrepared...
      // ui.addDefaultUserPreferences();
      this.session.userInfo = ui;

      // ui is back to normal now.
      ui = this.session.userInfo;

      /*
      console.log('ProVersion: ' + ui.hasProVersion);
      console.log('ScheduleModule: ' + ui.hasScheduleModule);
      console.log('TimesheetModule: ' + ui.hasTimesheetModule);
      console.log('PayModule: ' + ui.hasPayModule);

      console.log('Modules ',ui.modules);
      */

      // console.log('WeekStart of the connected User: ' + JSON.stringify(this.session.userInfo.weekStart, null,2));
      // console.log('Info about the connected User: ' + JSON.stringify(this.session.userInfo.user, null,2));
      // console.log('Prefs of the connected User: ' + JSON.stringify(this.session.userInfo.prefs, null,2));
      // console.log('Info about the connected User: ' + JSON.stringify(ui.user, null,2));
      // console.log('Info about the connected User: ' + JSON.stringify(this.session.userInfo.user, null,2));
      // console.log("Role: " + ui.user.userRole +" " + ui.user.userRole.toString() + " admin code is: " + UsagerRole.SYS_ADMIN.code);

      // if (UsagerRole.SYS_ADMIN === UsagerRole.retrieveFromCode('SYS_ADMIN')){
      //   console.log('reCreation is working...');
      // }
      // console.log('Remember Me? ' + this.rememberMe);
      if (this.rememberMe){
        // console.log('storing username');
        this.session.storeUserName(this.info.username);
      }else{
        this.session.clearStoredUserName();
      }
      this.session.changeLanguage();
      this.session.storeLocale(ui.locale);
      this.session.verifyTimeZone();

      if (ui.user.twoFactorAuthentication && loginWithToken===false){
        console.log('TwoFactorAuthentication');
        const modalRef = this.modalService.open(DlgAskOTP);
        // modalRef.componentInstance.populate(this.info.username,this.info.pwd);
        modalRef.result.then((result) => {
          console.log('Result: ',result);
          this.clientService.verifyOTP(ui.user.username,result).then(
            (res) => {
              if (res.success) {
                  this._showUI(loginWithToken);
              }
              this.loading = false;
            }
          );
        });
      }else{
        this._showUI(loginWithToken);
      }
    } else {
      if (<any>res.data === 111) {
        const modalRef = this.modalService.open(DlgErrorMessage);
        this.alertService.registerModal(modalRef);

        modalRef.componentInstance.populate(this.translate.instant('Error'), this.translate.instant('UserNameAndPasswordIsRightNoRightsOnAnyUnit'));
        modalRef.result.then((result) => {

        });
      }else if (<any>res.data === 112){
        const modalRef = this.modalService.open(DlgErrorMessage);
        this.alertService.registerModal(modalRef);

        modalRef.componentInstance.populate(this.translate.instant('Error'),this.translate.instant('UserNameAndPasswordIsRightNoRightsOnAnyEnterprise'));
        modalRef.result.then((result) => {

        });
      }else{
        console.log('Cant logging ',res);
        this.popupServices.errorMessage(res.description,res.data);
        // this.resultMessage = res.description;
        // this.alertService.error(res.description, res.data);
      }
      this.loading = false;
    }

  }

  private _showUI(loginWithToken=false){


    if (this.session.isSysAdmin()) {
      this.router.navigate(['/halfGod/searchEmployees']);
      this.session.homePath = '/halfGod';
      this.loading = false;
    } else {

      if (this.session.userInfo.shouldVerifyEmail && loginWithToken===false){
        console.log('Should verify Email');
        const modalRef = this.modalService.open(DlgUpdateEmailComponent);
        modalRef.componentInstance.populate(this.session.userInfo.user.employeeCode,this.session.userInfo.email)
        modalRef.result.then((result) => {
          console.log('Result: ' + result);
          this._displayNormalUI();
          /*
          this.clientService.updateEmail(this.session.userInfo.user.employeeCode,result).then(
            (res) => {
              if (res.success) {
              }
              this.loading = false;
            }
          );

           */
        });

      }else{
        this._displayNormalUI();
      }



    }
  }

  private _displayNormalUI(){

    this.chatService.ngOnInit()

    this.session.homePath = '/home';
    const userPref = this.session.userInfo.getPref(PrefName.USE_ALTERNATE_UI);
    if (userPref!=null){
      if (userPref.asBoolean()) {
        this.session.homePath = '/home-with-menus';
       // this.session.homePath = '/home-ng';
      }
    }
    const uiVersion = this.session.userInfo.getPref(PrefName.UI_VERSION);
    console.log('uiVersion: ',uiVersion);
    if (!Utils.isNullOrUndefined(uiVersion) && !Utils.isNullOrUndefined(uiVersion.prefValue)) {

      if (uiVersion.prefValue.toUpperCase() === 'EMPREZ_UI_V1'){
        this.session.homePath = '/home';
      }
      if (uiVersion.prefValue.toUpperCase() === 'EMPREZ_UI_V2'){
        this.session.homePath = '/home-with-menus';
      }
      if (uiVersion.prefValue.toUpperCase() === 'EMPREZ_UI_V2.1'){
        this.session.homePath = '/home-ng';
      }
      if (uiVersion.prefValue.toUpperCase() === 'EMPREZ_UI_V3'){
        this.session.homePath = '/home-concept';

        // changeFont() {
        document.documentElement.style.setProperty('--emprez-font-family', 'Nunito');
          // document.documentElement.style.setProperty('--emprez-font-family', 'Montserrat');
        document.documentElement.style.setProperty('--emprez-font-weight', '300');
        // }

      }
    }



    const demoAccount = this.session.userInfo.getPref(PrefName.DEMO_ACCOUNT);
    if (demoAccount!=null){
      if (demoAccount.asBoolean()){
        this.session.homePath = '/demo';
      }
    }


    this.router.navigate([this.session.homePath + '/dashboard']);
    this.loading = false;
  }


  /*
    // console.log('Initial App State', this.appState.state);
    this.clientService.loadConfiguration().then((config)=>{
    })
   */

  ngAfterContentInit() {

    Utils.testTimeZones();



    this.clientService.loadConfiguration().then((serverConfig) => {

      if (!Utils.isNullOrUndefined(serverConfig.version)){
        this.version = serverConfig.version.version + ' ('+serverConfig.version.build+')'
      }


      this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
        if (params.has('token')) {
          this.onTokenLogin(params.get('token'));
          //console.log('Automatic login!');
          // this.autom
        }
        if (params.has('user')){
          this.info.username = params.get('user');
          this.focusPassword = true;
        }else{
          if (serverConfig.username) {
            this.info.username = serverConfig.username;
          }
          if (serverConfig.pwd) {
            this.info.pwd = serverConfig.pwd;
          }
        }


      });


    });

    if (!this.info.username){
      this.info.username = this.session.getStoredUserName();
      if (this.info.username) {
        this.rememberMe = true;
      }
    }

    // this.info.username = 'Jerome';
    // contentChild is set after the content has been initialized
    console.log('AfterContentInit ' + this.info.username);
    if (!this.info.username) {
      console.log('focusing on Username ');
      this.focusUsername = true;
    }else {
      console.log('focusing on password');
      this.focusPassword = true;
    }
    console.log('focusUsername: ' + this.focusUsername + ' focusPassword: ' + this.focusPassword);
    // this.info.username = 'Jerome';
    // this.info.pwd = '';
  }

  onPasswordReminder(event:any){

    if (event.shiftKey){
      this.onLoginOpenId('GOOGLE');
      return;
    }

    const modalRef = this.modalService.open(DlgAskYesNoQuestion);
    modalRef.componentInstance.populate(this.translate.instant('QuestionTitle'),this.translate.instant('DoYouWantUsToSendYouANewPassword'));
    modalRef.result.then((result) => {
      console.log('Result: ' + result);
      if (ModalResult.YES === result){
        this.loading = true
        this.clientService.changeAndSendLostPassword(this.info.username).then(
          (res) => {
            this.popupServices.success(this.translate.instant('PasswordSentToEmailOnFile'))
            /*
            if (res.success) {
              this.alertService.success(this.translate.instant('NewPasswordSentTo',{recipient:res.data}));
            } else {
              this.loading = false;
              console.log('Error ' + res.description);
              this.alertService.error(res.description, res.data);
            }

             */
            this.loading = false;
          }
        );
      }
    });
  }

  onMeasureSpeed(event){

    // console.log('OnMeasureSpeed');
    if (this.lastSpeedMeasure){
      let start = new Date().getTime();
      if (start-this.lastSpeedMeasure.getTime()<5000){

        //console.log('OnMeasureSpeed too Quick! ' + (start - this.lastSpeedMeasure.getTime()) + " ms");

        return;
      }
    }


    if (event.shiftKey || event.altKey){
      let start = new Date().getTime();

      this.clientService.measureSpeed().then((res)=>{

        let end = new Date().getTime();


        // console.log('Res: ',res);

         this.popupServices.successMessageWithTitle(this.translate.instant('Speed'),this.translate.instant('SpeedTestIn',{ms:(end-start)}))

        this.lastSpeedMeasure = new Date();

      });


    }


  }


}

export class LoginInfo {
  username: string;
  pwd: string;
}
